import { Component, Input } from '@angular/core';
import { WidgetBoxItem } from 'src/app/shared/models/widget.model';

@Component({
    selector: 'ui-widget-container',
    templateUrl: './widget-container.component.html',
    styleUrls: ['./widget-container.component.scss'],
    standalone: false
})
export class WidgetContainerComponent {
  @Input() widgets: WidgetBoxItem[] = [];
  @Input() widgetStyle: 'internal' | 'external' = 'internal';
}
